(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('titulo-electronico-ang', {
            parent: 'entity',
            url: '/titulo-electronico-ang',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'verificadocumentoApp.tituloElectronico.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronicosang.html',
                    controller: 'TituloElectronicoAngController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tituloElectronico');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('titulo-electronico-ang-detail', {
            parent: 'titulo-electronico-ang',
            url: '/titulo-electronico-ang/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'verificadocumentoApp.tituloElectronico.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronico-ang-detail.html',
                    controller: 'TituloElectronicoAngDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tituloElectronico');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TituloElectronico', function($stateParams, TituloElectronico) {
                    return TituloElectronico.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'titulo-electronico-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('titulo-electronico-ang-detail.edit', {
            parent: 'titulo-electronico-ang-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronico-ang-dialog.html',
                    controller: 'TituloElectronicoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TituloElectronico', function(TituloElectronico) {
                            return TituloElectronico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('titulo-electronico-ang.new', {
            parent: 'titulo-electronico-ang',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronico-ang-dialog.html',
                    controller: 'TituloElectronicoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                contenido: null,
                                folioControl: null,
                                nombreGrado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('titulo-electronico-ang', null, { reload: 'titulo-electronico-ang' });
                }, function() {
                    $state.go('titulo-electronico-ang');
                });
            }]
        })
        .state('titulo-electronico-ang.edit', {
            parent: 'titulo-electronico-ang',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronico-ang-dialog.html',
                    controller: 'TituloElectronicoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TituloElectronico', function(TituloElectronico) {
                            return TituloElectronico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('titulo-electronico-ang', null, { reload: 'titulo-electronico-ang' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('titulo-electronico-ang.delete', {
            parent: 'titulo-electronico-ang',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-electronico-ang-delete-dialog.html',
                    controller: 'TituloElectronicoAngDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TituloElectronico', function(TituloElectronico) {
                            return TituloElectronico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('titulo-electronico-ang', null, { reload: 'titulo-electronico-ang' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('titulo-electronico-registrado', {
            parent: 'entity',
            url: '/titulo/{folioControl}',
            data: {
                pageTitle: 'verificadocumentoApp.tituloElectronico.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/titulo-electronico-ang/titulo-registrado.html',
                    controller: 'TituloElectronicoAngDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tituloElectronico');
                    return $translate.refresh();
                }],           
                entity: ['$stateParams', 'TituloRegistrado', function($stateParams, TituloRegistrado) {
                    return TituloRegistrado.get({folioControl : $stateParams.folioControl}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'titulo-electronico-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
